import { cx } from 'class-variance-authority';
import { jsx as _jsx } from "react/jsx-runtime";
var ContentTypeChip = function ContentTypeChip(_ref) {
  var contentType = _ref.contentType,
    _ref$capitalize = _ref.capitalize,
    capitalize = _ref$capitalize === void 0 ? true : _ref$capitalize,
    className = _ref.className;
  return /*#__PURE__*/_jsx("div", {
    className: cx(
    // Font
    'tw-font-body5 tw-text-neutral-light-700 dark:tw-text-neutral-dark-300 tw-w-fit',
    // Rounding
    'tw-rounded-1.6',
    // Padding
    'tw-py-0 tw-px-1',
    // Border
    'tw-border tw-border-solid tw-border-neutral-light-700 dark:tw-border-neutral-dark-300',
    // Capitalize
    capitalize && 'tw-capitalize', className),
    children: contentType
  });
};
export default ContentTypeChip;